/**
 * The wallet line's words (P2.8-T38, P2.8-T59 and P2.8-T67, ADR-124 decision 5.5 and its notes for P2.8-T59 and P2.8-T67):
 * each coin's name, one and many (the players' names are the author's, ADR-124's answer 1: "Sovereign, Talon, Bit"),
 * the stand-in currencies' names (Bible 10.1's and ADR-124's note for P2.8-T59), the line a stand-in currency's tooltip
 * opens with (`{name}` is `standin.honor`, `marks` or `tokens`) and the accessible name of the group of coin parts.
 * Drafts for the author unless said here.
 */
export const WALLET = {
  coins: {
    goldOne: "Sovereign",
    goldMany: "Sovereigns",
    silverOne: "Talon",
    silverMany: "Talons",
    copperOne: "Bit",
    copperMany: "Bits",
  },
  standin: {
    honor: "Honor",
    marks: "Marks of the Lyceum",
    tokens: "Inscription Tokens",
  },
  standinNotEarned: "{name}: not earned yet",
  coinsGroup: "Valish coin",
} as const;
